/* eslint-disable */
import { parsePhoneNumber, getRegionCodeForCountryCode } from "awesome-phonenumber";

// empty space validation fucntion
const CheckValid = (value, states) => {
  const EmailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/; // eslint-disable-line
  const EmailEmotaradRegex = /^[a-zA-Z0-9._%+-]+@(emotorad\.in|emotorad\.com)$/;
  // const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/; // eslint-disable-line
  const PasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@?!])[A-Za-z\d@?!]{8,}$/; // eslint-disable-line
  const pocRegex = /^\d{10}$/;
  const pinRegex = /^\d{6}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  function checksum(gstNumber) {
    const gstRegex =
      /^(?:(\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1})|(\d{2}[A-Z]{4}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}))$/;
    return gstRegex.test(gstNumber);
  }

  // function validateVehicleNumber(vehicleNumber) {
  //     const vehicleRegex = /^([A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4})$/;
  //     return vehicleRegex.test(vehicleNumber);
  // }

  // email validation
  if (states?.type === "email") {
    if (value !== "") {
      if (EmailRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (EmailRegex.test(value) === false) {
          return states?.error("Please enter valid email address");
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("Email address cannot be empty");
      } else if (EmailRegex.test(value) === false) {
        return states?.error("Please enter valid email address");
      } else {
        return states?.error("");
      }
    }
  }

  // email emotard format validation
  if (states?.type === "email_emotorad") {
    if (value !== "") {
      if (EmailEmotaradRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (EmailEmotaradRegex.test(value) === false) {
          return states?.error("Please enter valid emotorad email address");
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("Email address cannot be empty");
      } else if (EmailEmotaradRegex.test(value) === false) {
        return states?.error("Please enter valid emotorad email address");
      } else {
        return states?.error("");
      }
    }
  }

  // password validation
  if (states?.type === "password") {
    // if(value !== "") {
    //     if(PasswordRegex.test(value) === true) {
    //         return states?.error("");
    //     } else {
    //         if(PasswordRegex.test(value) === false) {
    //             return states?.error("Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.");
    //         } else {
    //             return states?.error("");
    //         }
    //     }
    // } else {
    //     if (value === "") {
    //         return states?.error("Password cannot be empty");
    //     } else if(PasswordRegex.test(value) === false) {
    //         return states?.error("Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.");
    //     } else {
    //         return states?.error("");
    //     }
    // }
    if (value !== "") {
      // if(PasswordRegex.test(value) === true) {
      //     return states?.error("");
      // } else {
      //     if(PasswordRegex.test(value) === false) {
      //         return states?.error("Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.");
      //     } else {
      //         return states?.error("");
      //     }
      // }
      return states?.error("");
    } else {
      // if (value === "") {
      //     return states?.error("Password cannot be empty");
      // } else if(PasswordRegex.test(value) === false) {
      //     return states?.error("Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.");
      // } else {
      //     return states?.error("");
      // }
      if (value === "") {
        return states?.error("Password cannot be empty");
      }
    }
  }

  // confirmPassword validation
  if (states?.type === "confirmPassword") {
    if (value !== "") {
      if (PasswordRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (PasswordRegex.test(value) === false) {
          return states?.error(
            "Confirm passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
          );
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("Confirm password cannot be empty");
      } else if (PasswordRegex.test(value) === false) {
        return states?.error(
          "Confirm passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
        );
      } else {
        return states?.error("");
      }
    }
  }

  // TransactionPassword validation
  if (states?.type === "TransactionPassword") {
    if (value !== "") {
      if (PasswordRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (PasswordRegex.test(value) === false) {
          return states?.error(
            "Transaction passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
          );
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("Transaction password cannot be empty");
      } else if (PasswordRegex.test(value) === false) {
        return states?.error(
          "Transaction passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
        );
      } else {
        return states?.error("");
      }
    }
  }

  // ConfirmTransactionPassword validation
  if (states?.type === "ConfirmTransactionPassword") {
    if (value !== "") {
      if (PasswordRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (PasswordRegex.test(value) === false) {
          return states?.error(
            "Confirm transaction passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
          );
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("Confirm transaction password cannot be empty");
      } else if (PasswordRegex.test(value) === false) {
        return states?.error(
          "Confirm transaction passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
        );
      } else {
        return states?.error("");
      }
    }
  }

  // old password validation
  if (states?.type === "oldpassword") {
    if (value !== "") {
      if (PasswordRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (PasswordRegex.test(value) === false) {
          return states?.error(
            "Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
          );
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("Old Password cannot be empty");
      } else if (PasswordRegex.test(value) === false) {
        return states?.error(
          "Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
        );
      } else {
        return states?.error("");
      }
    }
  }

  // new password validation
  if (states?.type === "newpassword") {
    if (value !== "") {
      if (PasswordRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (PasswordRegex.test(value) === false) {
          return states?.error(
            "Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
          );
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("New Password cannot be empty");
      } else if (PasswordRegex.test(value) === false) {
        return states?.error(
          "Passwords must contain at least one number, one uppercase and one lowercase letter, and at least 8 or more characters.",
        );
      } else {
        return states?.error("");
      }
    }
  }

  // first name validation
  if (states?.type === "FullName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Full name cannot be empty");
    }
  }

  // state name validation
  if (states?.type === "StateName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("State name cannot be empty");
    }
  }

  // RMuser validation
  if (states?.type === "RMuser") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("RMuser cannot be empty");
    }
  }

  // State Code validation
  if (states?.type === "StateCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("State code cannot be empty");
    }
  }

  // State Code validation
  if (states?.type === "CityName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("City name cannot be empty");
    }
  }
  // GSTCode validation
  if (states?.type === "GSTCode") {
    if (value !== "") {
      if (value?.length === 2) {
        return states?.error("");
      } else {
        return states?.error("Please enter two digit code.");
      }
    } else {
      return states?.error("GST code cannot be empty");
    }
  }

  // first name validation
  if (states?.type === "courier_name") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Courier name cannot be empty.");
    }
  }
  // track_link  validation
  if (states?.type === "tracking_link") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Tracking Link Is Required");
    }
  }
  // first name validation
  // if(states?.type === "vehicle_no"){
  //     if(value !== "") {
  //         return states?.error("");
  //     } else {
  //         return states?.error("Vehicle no Is Required");
  //     }
  // }
  // first name validation
  if (states?.type === "Remark") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Remarks Is Required");
    }
  }

  //slug validation

  if (states?.type === "slug") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Slug Is Required");
    }
  }
  //vendor id validation
  if (states?.type === "vendor_id") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Vendor Id Is Required");
    }
  }
  //service type
  if (states?.type === "service_type") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Service Type Is Required");
    }
  }
  //service_type_air
  // if(states?.type === "service_type_air"){
  //     if(value !== "") {
  //         return states?.error("");
  //     } else {
  //         return states?.error("Service Type Air Is Required");
  //     }
  // }

  // Dispatch Name validation
  if (states?.type === "DispatchName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Dispatch name cannot be empty");
    }
  }

  // first name validation
  if (states?.type === "FranchiseTypeName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Franchise type name cannot be empty");
    }
  }

  // ParentTypeId validation
  if (states?.type === "ParentTypeId") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select parent dealer type");
    }
  }

  // box selction
  if (states?.type === "BoxSelects") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select box");
    }
  }

  // CheckParentSubFrnchState validation
  if (states?.type === "CheckParentSubFrnchState") {
    if (value === true) {
      return states?.error("");
    } else {
      return states?.error(
        "The sub-dealer's state and the parent state should be the same. Please enter the pincode according to the parent state.",
      );
    }
  }

  // first name validation
  if (states?.type === "RegisteredBusinessName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Registered business name cannot be empty");
    }
  }

  // PrimaryContact validation
  if (states?.type === "PrimaryContact") {
    const PhoneCode = 91;
    const CountryStates = getRegionCodeForCountryCode(PhoneCode);
    const CheckMobileNumber = parsePhoneNumber(value?.toString(), {
      regionCode: CountryStates,
    });
    if (value !== "") {
      if (CheckMobileNumber?.valid === true) {
        return states?.error("");
      } else {
        return states?.error(`Please enter valid primary contact`);
      }
    } else {
      if (value === "") {
        return states?.error("Primary contact cannot be empty");
      } else if (CheckMobileNumber?.valid === false) {
        return states?.error("Please enter valid primary contact");
      } else {
        return states?.error("");
      }
    }
  }

  // Dealer validation
  if (states?.type === "dealer_franchise") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select dealer");
    }
  }

  // first name validation
  if (states?.type === "FranchiseTypeid") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select franchise type");
    }
  }

  // GSTNumber validation
  if (states?.type === "GSTNumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("GST number cannot be empty");
    }
  }
  // GSTNumber validation
  if (states?.type === "gst_no") {
    if (value !== "") {
      if (value.length >= 15) {
        return states?.error("Please enter a valid GST number");
      }
      if (checksum(value)) {
        return states?.error("");
      } else {
        return states?.error("Please enter a valid GST number");
      }
    } else {
      return states?.error("GST number cannot be empty");
    }
  }

  // CreditLimit validation
  if (states?.type === "CreditLimit") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Credit limit cannot be empty");
    }
  }

  // Franchise type credit
  if (states?.type === "FranchiseTypeCredit") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Franchise type credit cannot be empty");
    }
  }

  // first name validation
  if (states?.type === "Fname") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("First name cannot be empty");
    }
  }

  // customer name validation
  if (states?.type === "Customername") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Customer name cannot be empty");
    }
  }

  // WarehouseCode validation
  if (states?.type === "WarehouseCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Warehouse code cannot be empty");
    }
  }

  // PANCard validation
  if (states?.type === "PANCard") {
    if (value !== "") {
      if (panRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (panRegex.test(value) === false) {
          return states?.error("Please enter valid PAN card");
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("PAN card cannot be empty");
      } else if (panRegex.test(value) === false) {
        return states?.error("Please enter valid PAN card");
      } else {
        return states?.error("");
      }
    }
  }

  // POCName validation
  if (states?.type === "POCName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("POC name cannot be empty");
    }
  }

  // POCNumber validation
  if (states?.type === "POCNumber") {
    if (value !== "") {
      if (pocRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (pocRegex.test(value) === false) {
          return states?.error("Please enter valid POC number");
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("POC number cannot be empty");
      } else if (pocRegex.test(value) === false) {
        return states?.error("Please enter valid POC number");
      } else {
        return states?.error("");
      }
    }
  }

  // GSTIN validation
  if (states?.type === "GSTIN") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("GSTIN cannot be empty");
    }
  }

  // CIN validation
  if (states?.type === "CIN") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("CIN cannot be empty");
    }
  }

  // last name validation
  if (states?.type === "Lname") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Last name cannot be empty");
    }
  }

  // first name validation
  if (states?.type === "SupplierName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Supplier name cannot be empty");
    }
  }

  // WarehouseName validation
  if (states?.type === "WarehouseName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Warehouse name cannot be empty");
    }
  }

  // ContactPersonName validation
  if (states?.type === "ContactPersonName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Contact person name cannot be empty");
    }
  }

  // Currency validation
  if (states?.type === "Currency") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Currency cannot be empty");
    }
  }

  // RegionName validation
  if (states?.type === "RegionName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Region name cannot be empty");
    }
  }

  // Warehouse Types validation
  if (states?.type === "WarehouseType") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Warehouse type cannot be empty");
    }
  }

  // Refurbished point type validation
  if (states?.type === "RefurbishedPoint") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Point name cannot be empty");
    }
  }

  // Start Score validation
  if (states?.type === "StartPoint") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Start score cannot be empty");
    }
  }

  // End Score validation
  if (states?.type === "EndPoint") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("End score cannot be empty");
    }
  }

  // Point Score validation
  if (states?.type === "PointScore") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Score cannot be empty");
    }
  }

  // Percentage Score validation
  if (states?.type === "Percentage") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Percentage cannot be empty");
    }
  }

  // RegionSelect validation
  if (states?.type === "RegionSelect") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select region");
    }
  }

  // Returnremark validation
  if (states?.type === "Returnremark") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Return  mark cannot be empty");
    }
  }

  // title validation
  if (states?.type === "Title") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Title cannot be empty");
    }
  }

  // WebSiteUrl validation
  if (states?.type === "WebSiteUrl") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("WebSite cannot be empty");
    }
  }

  // Business name validation
  if (states?.type === "Business_name") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Business name cannot be empty");
    }
  }

  // Address validation
  if (states?.type === "Address") {
    if (value.trim() !== "") {
      if (value.length <= 300) {
        return states?.error("");
      } else {
        return states?.error("Address must be 100 characters or less");
      }
    } else {
      return states?.error("Address cannot be empty");
    }
  }
  // Address validation
  if (states?.type === "address2") {
    if (value.trim() !== "") {
      if (value.length <= 300) {
        return states?.error("");
      } else {
        return states?.error("Address must be 100 characters or less");
      }
    } else {
      return states?.error("");
    }
  }

  // Remarks validation
  if (states?.type === "Remarks") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Remarks cannot be empty");
    }
  }

  // Username validation
  if (states?.type === "UserName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("User name cannot be empty");
    }
  }

  // phone validation
  if (states?.type === "phone") {
    const PhoneCode = 91;
    const CountryStates = getRegionCodeForCountryCode(PhoneCode);
    const CheckMobileNumber = parsePhoneNumber(value?.toString(), {
      regionCode: CountryStates,
    });
    if (value !== "") {
      if (CheckMobileNumber?.valid === true) {
        return states?.error("");
      } else {
        return states?.error(`Please enter valid region mobile number`);
      }
    } else {
      if (value === "") {
        return states?.error("Mobile number cannot be empty");
      } else if (CheckMobileNumber?.valid === false) {
        return states?.error("please enter valid region mobile number");
      } else {
        return states?.error("");
      }
    }
  }

  // Product Name validation
  if (states?.type === "ProductName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product name cannot be empty");
    }
  }

  // MOQ validation
  if (states?.type === "MOQ") {
    if (value) {
      return states?.error("");
    } else {
      return states?.error("MOQ cannot be empty");
    }
  }

  // Product Name validation
  if (states?.type === "Model") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Model cannot be empty");
    }
  }

  // Brand validation
  if (states?.type === "BrandName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Brand name cannot be empty");
    }
  }

  // ProductGroupName validation
  if (states?.type === "ProductGroupName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product group name cannot be empty");
    }
  }

  // Brand validation
  if (states?.type === "SelectBrand") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select a brand");
    }
  }

  // category validation
  if (states?.type === "SelectCategory") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select a category");
    }
  }

  // Select SubCategory validation
  if (states?.type === "SelectSubCategory") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select a sub category");
    }
  }

  // BrandImage validation
  if (states?.type === "BrandImage") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Image cannot be empty");
    }
  }

  // MasterSKU validation
  if (states?.type === "MasterSKU") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Master SKU cannot be empty");
    }
  }

  // billing_number validation
  if (states?.type === "billing_number") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Billing number cannot be empty");
    }
  }

  // ProductName validation
  if (states?.type === "ProductName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product name cannot be empty");
    }
  }

  // DisplayName validation
  if (states?.type === "DisplayName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Display name cannot be empty");
    }
  }

  // ProductGroup validation
  if (states?.type === "ProductGroup") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product group cannot be empty");
    }
  }

  // ProductDescription validation
  if (states?.type === "ProductDescription") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product description cannot be empty");
    }
  }

  // HSNCode validation
  if (states?.type === "HSNCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("HSN code cannot be empty");
    }
  }

  // MRP validation
  if (states?.type === "MRP") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("MRP cannot be empty");
    }
  }

  // FranchiseRate validation
  if (states?.type === "FranchiseRate") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Franchise rate cannot be empty");
    }
  }

  // DemoRate validation
  if (states?.type === "DemoRate") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Demo rate cannot be empty");
    }
  }

  // RetailPrice validation
  if (states?.type === "RetailPrice") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Retail price cannot be empty");
    }
  }

  // FSCode validation
  if (states?.type === "FSCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("FS code cannot be empty");
    }
  }

  // ProductColor validation
  if (states?.type === "ProductColor") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product color cannot be empty");
    }
  }

  // IGSTRate validation
  if (states?.type === "IGSTRate") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("IGST rate cannot be empty");
    }
  }

  // DiscountAmount validation
  if (states?.type === "DiscountAmount") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Discount amount cannot be empty");
    }
  }

  // ECommPrice validation
  if (states?.type === "ECommPrice") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("EComm Price cannot be empty");
    }
  }

  // Select brand validation
  if (states?.type === "Select Brand") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select brand");
    }
  }

  // Select Warehouse validation
  if (states?.type === "Select Warehouse") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select Warehouse");
    }
  }

  // Select Dispatch validation
  if (states?.type === "Select Dispatch") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select Dispatch");
    }
  }

  // Unit const price validation
  if (states?.type === "Unitconstprice") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Unit cost price cannot be empty");
    }
  }

  // Unit const price validation
  if (states?.type === "Description") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Description cannot be empty");
    }
  }

  // Supplier name validation
  if (states?.type === "SupplierName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Supplier name cannot be empty");
    }
  }

  // Supplier name validation
  if (states?.type === "SupplierSelect") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select supplier");
    }
  }

  // permission validation
  if (states?.type === "permission") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select permisssion");
    }
  }

  // brand name validation
  if (states?.type === "Brand Name") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Brand name cannot be empty");
    }
  }

  // SubCategoryName validation
  if (states?.type === "SubCategoryName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Sub category name cannot be empty");
    }
  }

  // SubCategoryName select validation
  if (states?.type === "SubCategoryNameSelect") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select Sub category");
    }
  }

  // model name validation
  if (states?.type === "Model Name") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Model name cannot be empty");
    }
  }

  // Company name validation
  if (states?.type === "CompanyName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Company name cannot be empty");
    }
  }

  // VATRegistrationNo name validation
  if (states?.type === "VATRegistrationNo") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("VAT registration no cannot be empty");
    }
  }

  // RegistrationNo name validation
  if (states?.type === "RegistrationNo") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Registration no cannot be empty");
    }
  }

  // Amount validation
  if (states?.type === "Amount") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Amount cannot be empty");
    }
  }

  // InCoterm validation
  if (states?.type === "InCoterm") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("In-Coterm cannot be empty");
    }
  }

  // Quantity validation
  if (states?.type === "Quantity") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Quantity cannot be empty");
    }
  }

  // ItemNumber validation
  if (states?.type === "ItemNumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Item number cannot be empty");
    }
  }

  // PI number validation
  if (states?.type === "PInumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("PI-number cannot be empty");
    }
  }

  // PIN code validation
  if (states?.type === "PINCode") {
    if (value !== "") {
      if (pinRegex.test(value) === true) {
        return states?.error("");
      } else {
        if (pinRegex.test(value) === false) {
          return states?.error("Please enter valid PIN code");
        } else {
          return states?.error("");
        }
      }
    } else {
      if (value === "") {
        return states?.error("PIN code cannot be empty");
      } else if (pinRegex.test(value) === false) {
        return states?.error("Please enter valid PIN code");
      } else {
        return states?.error("");
      }
    }
  }

  // HSCode validation
  if (states?.type === "HSCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("HS-code cannot be empty");
    }
  }

  // PcCode validation
  if (states?.type === "PcCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("PcCode cannot be empty");
    }
  }

  // Category Name validation
  if (states?.type === "CategoryName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Category Name cannot be empty");
    }
  }

  // setting name validation
  if (states?.type === "Setting Name") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Field name cannot be empty");
    }
  }

  // box_name validation
  if (states?.type === "box_name") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Box name cannot be empty");
    }
  }

  // box_height validation
  if (states?.type === "box_height") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Box height cannot be empty");
    }
  }

  // box_width validation
  if (states?.type === "box_width") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Box width cannot be empty");
    }
  }

  // box_length validation
  if (states?.type === "box_length") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Box length cannot be empty");
    }
  }

  // box_weight validation
  if (states?.type === "box_weight") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Box weight cannot be empty");
    }
  }

  // basket_height validation
  if (states?.type === "basket_height") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Basket height cannot be empty");
    }
  }

  // basket_width validation
  if (states?.type === "basket_width") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Basket width cannot be empty");
    }
  }

  // basket_length validation
  if (states?.type === "basket_length") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Basket length cannot be empty");
    }
  }

  // basket_weight validation
  if (states?.type === "basket_weight") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Basket weight cannot be empty");
    }
  }

  // Adjust Type
  if (states?.type === "adjust_type") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Adjust type  cannot be empty");
    }
  }
  // adjust_amount
  if (states?.type === "adjust_amount") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Adjust amount  cannot be empty");
    }
  }
  // reason
  if (states?.type === "reason") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Reason cannot be empty");
    }
  }
  // reason_type
  if (states?.type === "reason_type") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Reason type cannot be empty");
    }
  }

  // reason_type
  if (states?.type === "FrameColor") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Frame color cannot be empty");
    }
  }

  if (states?.type === "FrameNumber") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Frame number cannot be empty");
    }
  }

    if(states?.type === "PurchaseDate"){
        if(value !== "") {
            return states?.error("");
        } else {
            return states?.error("Purchase date cannot be empty");
        }
    }

  if (states?.type === "DealerInfo") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Dealer info cannot be empty");
    }
  }

  if (states?.type === "franchise_name") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Franchise_name  cannot be empty");
    }
  }

  if (states?.type === "amount") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Amount  cannot be empty");
    }
  }
  if (states?.type === "RangeFrom") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Range from cannot be empty");
    }
  }
  if (states?.type === "RangeTo") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Range to cannot be empty");
    }
  }

  if (states?.type === "deposit_bank") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Deposit bank cannot be empty");
    }
  }
  if (states?.type === "transaction_number") {
    if (value !== "" && value !== null) {
      return states?.error("");
    } else {
      return states?.error("Transaction number cannot be empty");
    }
  }

  // MinDay validation
  if (states?.type === "MinDay") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Min day cannot be empty");
    }
  }

  // MaxDay validation
  if (states?.type === "MaxDay") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Max Day cannot be empty");
    }
  }

  // MonthlyTarget validation
  if (states?.type === "MonthlyTarget") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Monthly target cannot be empty");
    }
  }

  // OrderPriority validation
  if (states?.type === "OrderPriority") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select order priority");
    }
  }

  // AccountNumber validations
  if (states?.type === "AccountNumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please enter account number");
    }
  }

  // IFSCCode validations
  if (states?.type === "IFSCCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please enter IFSC code");
    }
  }

  // AadhaarNumber validations
  if (states?.type === "AadhaarNumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please enter aadhaar number");
    }
  }

  // Scheme name validations
  if (states?.type === "SchemeName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please enter scheme name");
    }
  }

  // Scheme code validations
  if (states?.type === "SchemeCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please enter scheme code");
    }
  }

  // incentive title validations
  if (states?.type === "IncentiveTitle") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please enter incentive title");
    }
  }

  // incentive code validations
  if (states?.type === "IncentiveCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select Incentive Slab");
    }
  }

  // Product select validation
  if (states?.type === "ProductSelect") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select product");
    }
  }

  // App Group validations
  if (states?.type === "AppGroupSelect") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select app group");
    }
  }

  // productValue validation
  if (states?.type === "productValue") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Product value cannot be empty");
    }
  }

  // invoiceNumber validations
  if (states?.type === "invoiceNumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Invoice number cannot be empty");
    }
  }
  if (states?.type === "DeliveryNumber") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Delivery Note number cannot be empty");
    }
  }

  // frame_number validations
  if (states?.type === "frame_number") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Frame number cannot be empty");
    }
  }

  // ticket_number validations
  if (states?.type === "ticket_number") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Ticket number cannot be empty");
    }
  }

  // Primary Item Code validations
  if (states?.type === "PrimaryItemCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please Select primary item code");
    }
  }

  // Compatible Item Code validations
  if (states?.type === "CompatibleItemCode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please Select compatible item code");
    }
  }

  // Compatible Item Name validations
  if (states?.type === "CompatibleItemName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error(
        "First select compatible item code & primary Item Code",
      );
    }
  }

  // Category type validations
  if (states?.type === "CategoryType") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please Select Category type");
    }
  }

  // Question validations
  if (states?.type === "Question") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Question cannot be empty");
    }
  }

  // Answer validations
  if (states?.type === "Answer") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Answer cannot be empty");
    }
  }

  // Payment Date Validations
  if (states?.type === "payment_date") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Payment date cannot be empty");
    }
  }

  // Payment mode Validations
  if (states?.type === "payment_mode") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Payment mode cannot be empty");
    }
  }

  // Upload attachment validations
  if (states?.type === "upload_attachment") {
    if (Object?.keys(value)?.length > 0) {
      return states?.error("");
    } else {
      return states?.error("Upload attachment cannot be empty");
    }
  }

  // Notification Title validation
  if (states?.type === "NotificationTitle") {
    if (Object?.keys(value)?.length > 0) {
      return states?.error("");
    } else {
      return states?.error("Notification title cannot be empty");
    }
  }

  // Notification Description validation
  if (states?.type === "NotificationDescription") {
    if (Object?.keys(value)?.length > 0) {
      return states?.error("");
    } else {
      return states?.error("Notification description cannot be empty");
    }
  }

  // Notification Start Date validation
  if (states?.type === "NotificationStartDate") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Start date cannot be empty");
    }
  }

  // Notification End Date validation
  if (states?.type === "NotificationEndDate") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("End date cannot be empty");
    }
  }

  // Notification Uploaded Image validation
  if (states?.type === "NotificationUploadedImage") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Upload image cannot be empty");
    }
  }

  // Notification Nps Url validations
  if (states?.type === "NotificationNpsUrl") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Nps url cannot be empty");
    }
  }

  // Campaign Title validation
  if (states?.type === "CampaignTitle") {
    if (Object?.keys(value)?.length > 0) {
      return states?.error("");
    } else {
      return states?.error("Campaign title cannot be empty");
    }
  }

  // Campaign Description validation
  if (states?.type === "CampaignDescription") {
    if (Object?.keys(value)?.length > 0) {
      return states?.error("");
    } else {
      return states?.error("Campaign description cannot be empty");
    }
  }

  // erp_credit_limit validations
  if (states?.type === "erp_credit_limit") {
    if (Object?.keys(value)?.length > 0) {
      return states?.error("");
    } else {
      return states?.error("Erp credit limit cannot be empty");
    }
  }

  // SubjectName validation
  if (states?.type === "SubjectName") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Subject cannot be empty");
    }
  }

  // ToEmail validation
  if (states?.type === "ToEmail") {
    if (value?.toString()?.length > 0) {
      if (value?.toString()?.length <= 500) {
        return states?.error("");
      } else {
        return states?.error("The maximum character limit is 500");
      }
    } else {
      return states?.error("To cannot be empty");
    }
  }

  // CcEmail validation
  if (states?.type === "CcEmail") {
    if (value?.toString()?.length > 0) {
      if (value?.toString()?.length <= 500) {
        return states?.error("");
      } else {
        return states?.error("The maximum character limit is 500");
      }
    } else {
      return states?.error("Cc cannot be empty");
    }
  }

  // MailFormat validation
  if (states?.type === "MailFormat") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Email preview cannot be empty");
    }
  }

  // SelectEvent validation
  if (states?.type === "SelectEvent") {
    if (value !== "") {
      return states?.error("");
    } else {
      return states?.error("Please select Event");
    }
  }

  // Warranty plans admin. `states.label` names the field in the message; `states.min` and
  // `states.max` narrow a whole number. The setter gets "" when the value is fine.
  if (states?.type === "warranty_tier_key") {
    const key = typeof value === "string" ? value : "";
    if (key === "") {
      return states?.error("Tier key cannot be empty");
    } else if (/^[a-z][a-z0-9_]{1,31}$/.test(key) === false) {
      return states?.error(
        "Use 2 to 32 characters: lower case letters, digits and underscores, starting with a letter"
      );
    } else {
      return states?.error("");
    }
  }

  if (states?.type === "warranty_reason") {
    const reason = typeof value === "string" ? value.trim() : "";
    if (reason.length === 0) {
      return states?.error("Reason cannot be empty");
    } else if (reason.length > 500) {
      return states?.error("The maximum character limit is 500");
    } else {
      return states?.error("");
    }
  }

  // Free text with a length range and an optional pattern. `states.min` and `states.max` count
  // characters; `states.pattern` (a RegExp) and `states.patternMessage` are optional.
  if (states?.type === "warranty_text") {
    const name = states?.label || "Value";
    const text = typeof value === "string" ? value : "";
    const min = states?.min === undefined ? 1 : states.min;
    if (text.trim().length < min) {
      return states?.error(
        min <= 1 ? `${name} cannot be empty` : `${name} needs at least ${min} characters`
      );
    } else if (text !== text.trim()) {
      return states?.error(`${name} cannot start or end with a space`);
    } else if (states?.max !== undefined && text.length > states.max) {
      return states?.error(`${name} can have at most ${states.max} characters`);
    } else if (states?.pattern && states.pattern.test(text) === false) {
      return states?.error(states?.patternMessage || `${name} is not valid`);
    } else {
      return states?.error("");
    }
  }

  // Warranty plan app content: optional text (blank is fine, it is sent as null) of at most
  // `states.max` characters. With `states.placeholders` (a list such as ["tierName"]), any other
  // {token} is refused, as the service refuses it.
  if (states?.type === "warranty_display_text") {
    const name = states?.label || "Text";
    const text = typeof value === "string" ? value : "";
    const tokens = text.match(/\{[^{}]*\}/g) || [];
    const unknown = Array.isArray(states?.placeholders)
      ? tokens.find((token) => !states.placeholders.includes(token.slice(1, -1)))
      : undefined;
    if (text.trim() === "" && states?.required === true) {
      return states?.error(`${name} cannot be empty`);
    } else if (states?.max !== undefined && text.length > states.max) {
      return states?.error(`${name} can have at most ${states.max} characters`);
    } else if (unknown !== undefined) {
      return states?.error(
        `${unknown} cannot be used here. Use ${states.placeholders.map((p) => `{${p}}`).join(" or ")}`
      );
    } else {
      return states?.error("");
    }
  }

  // Warranty plan terms link: blank is fine (sent as null); otherwise an https address.
  if (states?.type === "warranty_https_url") {
    const name = states?.label || "Link";
    const raw = typeof value === "string" ? value : "";
    const text = raw.trim();
    let parsed = null;
    try {
      parsed = text === "" ? null : new URL(text);
    } catch (error) {
      parsed = null;
    }
    if (text === "") {
      return states?.error("");
    } else if (states?.max !== undefined && text.length > states.max) {
      return states?.error(`${name} can have at most ${states.max} characters`);
    } else if (parsed === null || parsed.protocol !== "https:" || /\s/.test(raw)) {
      return states?.error(`${name} must be an https address, for example https://www.emotorad.com/terms`);
    } else {
      return states?.error("");
    }
  }

  if (states?.type === "warranty_rupees") {
    const name = states?.label || "Amount";
    const amount = typeof value === "string" ? value.trim() : "";
    if (amount === "") {
      return states?.error(`${name} cannot be empty`);
    } else if (/^\d+(\.\d{1,2})?$/.test(amount) === false) {
      return states?.error(`${name} must be a number with at most two decimals`);
    } else if (Number(amount) > 1000000000) {
      return states?.error(`${name} cannot be more than 1,000,000,000`);
    } else if (states?.positive === true && Number(amount) <= 0) {
      // A money amount that must have moved (the amount a provider refunded), never 0.
      return states?.error(`${name} must be more than 0`);
    } else {
      return states?.error("");
    }
  }

  if (states?.type === "warranty_percent") {
    const name = states?.label || "Percentage";
    const percent = typeof value === "string" ? value.trim() : "";
    if (percent === "") {
      return states?.error(`${name} cannot be empty`);
    } else if (/^\d+(\.\d{1,2})?$/.test(percent) === false) {
      return states?.error(`${name} must be a number with at most two decimals`);
    } else if (Number(percent) > 100) {
      return states?.error(`${name} cannot be more than 100`);
    } else {
      return states?.error("");
    }
  }

  if (states?.type === "warranty_whole_number") {
    const name = states?.label || "Value";
    const number = typeof value === "string" ? value.trim() : "";
    const min = states?.min === undefined ? 0 : states.min;
    if (number === "") {
      return states?.error(`${name} cannot be empty`);
    } else if (/^\d{1,9}$/.test(number) === false) {
      return states?.error(`${name} must be a whole number`);
    } else if (Number(number) < min) {
      return states?.error(`${name} cannot be less than ${min}`);
    } else if (states?.max !== undefined && Number(number) > states.max) {
      return states?.error(`${name} cannot be more than ${states.max}`);
    } else {
      return states?.error("");
    }
  }

  // Warranty ops: a purchase date as YYYY-MM-DD, a real calendar date, not after today, and not
  // before `states.min` (YYYY-MM-DD) when the caller gives one.
  if (states?.type === "warranty_date") {
    const text = typeof value === "string" ? value.trim() : "";
    const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
    if (text === "") {
      return states?.error("Purchase date cannot be empty");
    } else if (parts === null) {
      return states?.error("Enter the date as YYYY-MM-DD, for example 2026-03-14");
    }
    const year = Number(parts[1]);
    const month = Number(parts[2]);
    const day = Number(parts[3]);
    const real = new Date(year, month - 1, day);
    if (
      year < 2000 ||
      real.getFullYear() !== year ||
      real.getMonth() !== month - 1 ||
      real.getDate() !== day
    ) {
      return states?.error("That is not a real date");
    }
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (real.getTime() > today.getTime()) {
      return states?.error("The purchase date cannot be after today");
    }
    if (typeof states?.min === "string" && text < states.min) {
      return states?.error(`The purchase date cannot be before ${states.min}`);
    }
    return states?.error("");
  }

  // Warranty ops: a settlement month as YYYY-MM, not after `states.max` (the market's current
  // month, also YYYY-MM, which the screen works out in the market's time zone).
  if (states?.type === "warranty_month") {
    const text = typeof value === "string" ? value.trim() : "";
    const parts = /^(\d{4})-(\d{2})$/.exec(text);
    if (text === "") {
      return states?.error("Choose a month");
    } else if (parts === null) {
      return states?.error("Enter the month as YYYY-MM, for example 2026-09");
    } else if (Number(parts[1]) < 2000 || Number(parts[2]) < 1 || Number(parts[2]) > 12) {
      return states?.error("That is not a real month");
    } else if (typeof states?.max === "string" && text > states.max) {
      return states?.error("The month cannot be after the current month");
    }
    return states?.error("");
  }

  // Warranty ops: a frame number typed into the subscription search (1 to 40 characters).
  if (states?.type === "warranty_frame") {
    const text = typeof value === "string" ? value.trim() : "";
    if (text === "") {
      return states?.error("Frame number cannot be empty");
    } else if (text.length > 40) {
      return states?.error("A frame number has at most 40 characters");
    } else if (/[\u0000-\u001f\u007f]/.test(text)) {
      return states?.error("A frame number cannot contain control characters");
    }
    return states?.error("");
  }

  // Warranty All warranties search: a frame number, a mobile number or a registration id, in one box.
  if (states?.type === "warranty_registration_search") {
    const text = typeof value === "string" ? value.trim() : "";
    if (text === "") {
      return states?.error("Type a frame number, a phone or a registration id");
    } else if (text.length > 40) {
      return states?.error("A search has at most 40 characters");
    } else if (/[\u0000-\u001f\u007f]/.test(text)) {
      return states?.error("A search cannot contain control characters");
    }
    return states?.error("");
  }

  // Warranty ops: a subscription id as typed (a UUID).
  if (states?.type === "warranty_uuid") {
    const text = typeof value === "string" ? value.trim() : "";
    if (text === "") {
      return states?.error("Subscription id cannot be empty");
    } else if (
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        text
      ) === false
    ) {
      return states?.error("A subscription id looks like 0199a1b2-0000-7000-8000-000000000001");
    }
    return states?.error("");
  }

  // Warranty catalogue image (a component icon or a model image): blank is fine (sent as null,
  // meaning no image); otherwise an https address, which the Amigo app loads as it is.
  if (states?.type === "warranty_image_url") {
    const name = states?.label || "Image URL";
    const raw = typeof value === "string" ? value : "";
    const text = raw.trim();
    let parsed = null;
    try {
      parsed = text === "" ? null : new URL(text);
    } catch (error) {
      parsed = null;
    }
    if (text === "") {
      return states?.error("");
    } else if (states?.max !== undefined && text.length > states.max) {
      return states?.error(`${name} can have at most ${states.max} characters`);
    } else if (parsed === null || parsed.protocol !== "https:" || parsed.hostname === "" || /\s/.test(text)) {
      return states?.error(`${name} must be an https address, for example https://cdn.emotorad.com/warranty/frame.png`);
    }
    return states?.error("");
  }

  // Warranty catalogue product id: blank is fine (the image is for the whole product group).
  if (states?.type === "warranty_optional_uuid") {
    const name = states?.label || "Product id";
    const text = typeof value === "string" ? value.trim() : "";
    if (
      text !== "" &&
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(text) === false
    ) {
      return states?.error(`${name} must be blank or look like 0199a1b2-0000-7000-8000-000000000001`);
    }
    return states?.error("");
  }

  // Warranty vendor policy number, as typed off the vendor's PDF: the contract's rule, 1 to 64 of
  // letters, digits, space and . _ / - (checked after trimming the ends).
  if (states?.type === "warranty_vendor_policy_number") {
    const text = typeof value === "string" ? value.trim() : "";
    if (text === "") {
      return states?.error("Enter the policy number from the vendor's PDF");
    } else if (text.length > 64) {
      return states?.error("A policy number has at most 64 characters");
    } else if (/^[A-Za-z0-9 ._/-]+$/.test(text) === false) {
      return states?.error("A policy number can have letters, digits, spaces and . _ / - only");
    }
    return states?.error("");
  }

  // Warranty vendor policy PDF (a File): a .pdf name, a PDF type when the browser gives one, and at
  // most 10 MB (states.max, in bytes).
  if (states?.type === "warranty_vendor_policy_pdf") {
    const file = value;
    const name = typeof file?.name === "string" ? file.name.toLowerCase() : "";
    const type = typeof file?.type === "string" ? file.type : "";
    if (!file) {
      return states?.error("Choose the vendor's PDF");
    } else if (!name.endsWith(".pdf") || (type !== "" && type !== "application/pdf")) {
      return states?.error("Choose a PDF file. This file is not a PDF");
    } else if (!(file.size > 0)) {
      return states?.error("This file is empty. Choose the PDF again");
    } else if (file.size > states.max) {
      return states?.error("The PDF can be at most 10 MB");
    }
    return states?.error("");
  }
};;;

export default CheckValid;